import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctTimestamp, FctValue } from '../../../../Fct/generics/FctParams';
import { FaWater } from 'react-icons/fa';
import { votingEscrowContract } from '../helpers/supportedContracts';
export var CreateLock = createPlugin({
    protocol: 'CURVE',
    type: 'ACTION',
    method: 'create_lock',
    name: 'createCurveTokenLock',
    description: 'Deposit CRV into the contract and create a new lock.',
    supportedContracts: votingEscrowContract,
    getParams: function () { return ({
        input: {
            to: new FctAddress({ destination: 'curve_voting_escrow', options: votingEscrowContract, isPreview: true, }),
            methodParams: {
                value: new FctValue({ destination: 'wei_amount', decimals: 18, isPreview: true }),
                unlock_time: new FctTimestamp({ isPreview: true, icon: FaWater }),
            },
        },
        output: {},
    }); },
    requiredApprovals: function (params) {
        return [
            {
                to: '0xD533a949740bb3306d119CC777fa900bA034cd52',
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: params === null || params === void 0 ? void 0 : params.methodParams.value.value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
});
